export const WIDGET_DATA = { id: "new-starters", name: "New Starters" };